<template>
  <TheNavigation v-if="userStore.isLoggedIn && sidebarStore.showMenu" />
  <BaseToastContainer position="top-right" />
  <TheModalContainer />
  <RouterLayout />
  <TheInitialLoader />
</template>

<script setup lang="ts">
import TheNavigation from '@/components/TheNavigation.vue';
import RouterLayout from '@/layouts/RouterLayout.vue';
import { BaseToastContainer } from '@/components/Base';
import TheModalContainer from '@/components/TheModalContainer.vue';
import { useSidebarStore, useUserStore } from '@/stores';
import TheInitialLoader from '@/components/TheInitialLoader.vue';
const userStore = useUserStore();
const sidebarStore = useSidebarStore();
</script>

<style lang="scss" src="@/assets/styles/tooltip.scss"/>
